/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { UTILITY_TABS, UtilityType } from '../../../shared/Utils/Constants';
import UtilitySavingDetailsHOC, {
  IEnergyManagementHOCProps
} from '../UtilitySavingDetailHOC';

const GasUtility = (props: IEnergyManagementHOCProps) => {
  const gasProps = {
    ...props,
    ActiveIndex: UTILITY_TABS.TWO,
    utilityType: UtilityType.Gas
  };
  return <UtilitySavingDetailsHOC {...gasProps} />;
};

export default GasUtility;
